module.exports = __webpack_public_path__ + "static/highspeed_soln-a0e4db7e3ecfee657da5a0d5feb2f412.svg";